// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content.gridster-item-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 30px);
}

app-explore {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/feature-selector-widget/feature-selector-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AACF","sourcesContent":[".content.gridster-item-content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: calc(100% - 30px);\n}\n\napp-explore {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
